import { AdminPage } from "./pages/AdminPage";
import { HomePage } from "./pages/HomePage";
import { LiveDashboard } from "./pages/LiveDashboard";
import { ParticipantPage } from "./pages/ParticipantPage";

function NotFound() {
  return (
    <main className="center-page" id="main">
      <span className="giant-code">404</span>
      <h1>Esta nube no existe</h1>
      <a className="hw-btn hw-btn--primary" href="/">
        Volver al inicio
      </a>
    </main>
  );
}

export function App() {
  const path = location.pathname.replace(/\/+$/, "") || "/";
  if (path === "/") return <HomePage />;
  if (path === "/admin") return <AdminPage />;
  if (path === "/demo") return <LiveDashboard demo slug="demo" />;
  const participant = path.match(/^\/s\/([a-z0-9-]+)$/i);
  if (participant?.[1]) return <ParticipantPage slug={participant[1]} />;
  const live = path.match(/^\/live\/([a-z0-9-]+)$/i);
  if (live?.[1]) return <LiveDashboard slug={live[1]} />;
  return <NotFound />;
}

